const capitalize = (value: string) => (
  value.slice(0, 1).toUpperCase() + value.slice(1)
);

export default capitalize;
